import { SxProps, Theme } from "@/common/styles/style";

export const styles: { [key: string]: (type?: number) => SxProps<Theme> } = {
  container: (type) => ({
    width: type === 2 ? "760px" : "370px",
    height: "100%",
    border: "1px solid #ddd",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
  }),
  header: () => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 15px",
    ".MuiCardHeader-title": { fontSize: 16 },
    ".MuiCardHeader-action": { fontSize: 12 },
  }),
  cardHeaderTitle: () => ({
    fontSize: 14,
  }),
  paper: () => ({
    padding: "8px 16px",
  }),
  link: () => ({
    cursor: "pointer",
    textDecoration: "none",
    color: "#000",
  }),
  graph: () => ({
    height: "250px",
    minHeight: "100%",
    padding: "0 10px",
    alignItems: "center",
    fontSize: "13px",
  }),
  cardActions: () => ({
    display: "flex",
    justifyContent: "space-between",
  }),
  arrowIcon: () => ({
    fontSize: 12,
  }),
  actionText: () => ({
    margin: "6px 8px",
  }),
  data: () => ({
    height: "273px",
    padding: "10px 15px",
    alignItems: "center",
    fontSize: "13px",
    flexGrow: 1,
    overflowY: "auto",
    textAlign: "center",
  }),
};
